// extracted by mini-css-extract-plugin
module.exports = {"container":"svg_container__1RQo7","svg_container":"svg_svg_container__3Cuif","curve1":"svg_curve1__2m2k-","curve2":"svg_curve2__3vMXq","mtt":"svg_mtt__1YMh4"};